/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const SfcShell = /*@__PURE__*/ createReactComponent('sfc-shell');
export const SfcShellAppBar = /*@__PURE__*/ createReactComponent('sfc-shell-app-bar');
export const SfcShellAppBarIcon = /*@__PURE__*/ createReactComponent('sfc-shell-app-bar-icon');
export const SfcShellAppBarSearch = /*@__PURE__*/ createReactComponent('sfc-shell-app-bar-search');
export const SfcShellBreadcrumbs = /*@__PURE__*/ createReactComponent('sfc-shell-breadcrumbs');
export const SfcShellFooter = /*@__PURE__*/ createReactComponent('sfc-shell-footer');
export const SfcShellFooterLink = /*@__PURE__*/ createReactComponent('sfc-shell-footer-link');
export const SfcShellLeftNav = /*@__PURE__*/ createReactComponent('sfc-shell-left-nav');
export const SfcShellLeftNavFlat = /*@__PURE__*/ createReactComponent('sfc-shell-left-nav-flat');
export const SfcShellLeftNavV2 = /*@__PURE__*/ createReactComponent('sfc-shell-left-nav-v2');
export const SfcShellTopHat = /*@__PURE__*/ createReactComponent('sfc-shell-top-hat');
export const SfcShellTopNav = /*@__PURE__*/ createReactComponent('sfc-shell-top-nav');
export const SfcShellUni = /*@__PURE__*/ createReactComponent('sfc-shell-uni');
//# sourceMappingURL=sfc-components.js.map